import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../payment-link-system/PaymentLinkTable";
import {
  convertStraight,
  convertTimeRangeHHMMSS,
} from "../common-data/Converts";
import moment from "moment";
import ModalHeadAndClose from "../payouts-wtf/common/ModalHeadAndClose";
import TrainerMembers from "./TrainerMembers";
import OccupencyDetails from "../components-react/OccupencyDetails";
import {
  fetchDefaultTrainersData,
  fetchGTPTreportsDetails,
} from "../../redux/reducers/apiSlice";
import ABBdetail from "./ABBdetail";
import CheckinReports from "./common/CheckinReports";
import { BiArrowDownIcon, BiArrowUpIcon } from "../../images/icons/icons";

const TrainerMemberTable = ({
  user,
  allFilters,
  setAllFilters,
  filters,
  isPage,
  setIsPage,
  isGTPTreports,
  cardName,
}) => {
  const dispatch = useDispatch();
  const { defaultTrainers, loadingDTM, error } = useSelector(
    (state) => state.api
  );

  const iniTbDatas = {
    allData: null,
    pagination: [],
  };
  const [tbDatas, setTbDatas] = useState(iniTbDatas);
  const initialClickValues = {
    isModOpen: false,
    userId: "",
    type: "",
    trainerId: "",
    gymId: "",
    rowData: "",
    sendableStatsQPs: "",
  };
  const [clickValues, setClickValues] = useState(initialClickValues);
  const [shiftFormattedQP, setShiftFormattedQP] = useState("");

  const onCloseModal = () => {
    setClickValues(initialClickValues);
  };

  const onClickValues = (e, row, name) => {
    e.preventDefault();

    setClickValues((prevs) => ({
      ...prevs,
      isModOpen: true,
      trainerId: row?.trainer_id || "",
      gymId: row?.gym_id || "",
      clickedType: name,
    }));
  };

  function getGtTrainer() {
    dispatch(
      fetchGTPTreportsDetails({
        filters: filters,
        token: user?.token,
      })
    );
  }

  function getPtTrainer() {
    dispatch(
      fetchDefaultTrainersData({
        filters: filters,
        token: user?.token,
      })
    );
  }

  useEffect(() => {
    if (filters.filter_type) {
      if (isGTPTreports) {
        getGtTrainer();
      } else {
        getPtTrainer();
      }
    }
  }, [filters]);

  useEffect(() => {
    if (defaultTrainers?.status && defaultTrainers?.data && !error) {
      setTbDatas((prevs) => ({
        ...prevs,
        allData: defaultTrainers.data,
        pagination: defaultTrainers?.pagination || [],
      }));
    } else {
      setTbDatas(iniTbDatas);
    }
  }, [defaultTrainers]);

  useEffect(() => {
    const trainerQP = `&trainer_id=${clickValues.trainerId || ""}`;
    const gymQP = `&gym_id=${clickValues.gymId || ""}`;
    const allQP = `${trainerQP}${gymQP}`;
    setShiftFormattedQP(allQP);
  }, [clickValues.trainerId, clickValues.gymId]);

  const tbColumns = [
    {
      dataField: "gym_name",
      text: "gym name",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "trainer_name",
      text: "trainer name",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.trainer_name || "NA"}
            <br />
            <small className="lowercase underline">
              {row?.trainer_mobile || ""}
              <br />
              {row?.trainer_email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "total_assigned_members",
      text: "assigned members",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius8 hoverBlue"
            style={{
              background: "#BCBBF7",
              color: "#171717",
              padding: "10px 30px",
            }}
            onClick={() => {
              const shiftTimings = row?.shift_details?.map((shift) => {
                const startTime = shift?.start_time
                  ? moment(shift.start_time, "HH:mm")
                      .tz("Asia/Kolkata")
                      .format("h:mmA")
                  : "";
                const endTime = shift?.end_time
                  ? moment(shift.end_time, "HH:mm")
                      .tz("Asia/Kolkata")
                      .format("h:mmA")
                  : "";
                return `${startTime}-${endTime}`;
              });

              const shiftTiming = shiftTimings
                ? shiftTimings?.join(", ")
                : "No Shift Found";

              setClickValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                type: "member",
                clickedType: "assigned_members",
                userId: row?.trainer_id,
                rowValue: row?.total_assigned_members || 0,
                rowData: {
                  who: "trainer",
                  name: row?.trainer_name,
                  mobile: row?.trainer_mobile,
                  email: row?.trainer_email,
                  gym_name: row?.gym_name,
                  shiftTiming: shiftTiming,
                  last_checkin: row?.last_checkin,
                  checkin_time: row?.checkin_time,
                  last_checkin_days_ago: row?.last_checkin_days_ago,
                },
              }));
            }}
          >
            {row?.total_assigned_members || 0}
          </span>
        );
      },
    },
    {
      dataField: "total_biomax_registered",
      text: "Biomax Registered Members",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius8 hoverBlue"
            style={{
              background: "#BCBBF7",
              color: "#171717",
              padding: "10px 30px",
            }}
            onClick={() => {
              const shiftTimings = row?.shift_details?.map((shift) => {
                const startTime = shift?.start_time
                  ? moment(shift.start_time, "HH:mm")
                      .tz("Asia/Kolkata")
                      .format("h:mmA")
                  : "";
                const endTime = shift?.end_time
                  ? moment(shift.end_time, "HH:mm")
                      .tz("Asia/Kolkata")
                      .format("h:mmA")
                  : "";
                return `${startTime}-${endTime}`;
              });

              const shiftTiming = shiftTimings
                ? shiftTimings?.join(", ")
                : "No Shift Found";

              setClickValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                userId: row?.trainer_id,
                assignedMemModal: true,
                type: "member",
                clickedType: "biomax_registered",
                rowValue: row?.total_biomax_registered || 0,
                rowData: {
                  who: "trainer",
                  name: row?.trainer_name,
                  mobile: row?.trainer_mobile,
                  email: row?.trainer_email,
                  gym_name: row?.gym_name,
                  shiftTiming: shiftTiming,
                  last_checkin: row?.last_checkin,
                  checkin_time: row?.checkin_time,
                  last_checkin_days_ago: row?.last_checkin_days_ago,
                },
              }));
            }}
          >
            {row?.total_biomax_registered || 0}
          </span>
        );
      },
    },
    {
      dataField: "total_biomax_not_registered",
      text: "Biomax Not Registered Members",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius8 hoverBlue"
            style={{
              background: "#BCBBF7",
              color: "#171717",
              padding: "10px 30px",
              // display: "block",
              // width: "100px",
            }}
            onClick={() => {
              const shiftTimings = row?.shift_details?.map((shift) => {
                const startTime = shift?.start_time
                  ? moment(shift.start_time, "HH:mm")
                      .tz("Asia/Kolkata")
                      .format("h:mmA")
                  : "";
                const endTime = shift?.end_time
                  ? moment(shift.end_time, "HH:mm")
                      .tz("Asia/Kolkata")
                      .format("h:mmA")
                  : "";
                return `${startTime}-${endTime}`;
              });

              const shiftTiming = shiftTimings
                ? shiftTimings?.join(", ")
                : "No Shift Found";

              setClickValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                userId: row?.trainer_id,
                assignedMemModal: true,
                type: "member",
                clickedType: "biomax_not_registered",
                rowValue: row?.total_biomax_not_registered || 0,
                rowData: {
                  who: "trainer",
                  name: row?.trainer_name,
                  mobile: row?.trainer_mobile,
                  email: row?.trainer_email,
                  gym_name: row?.gym_name,
                  shiftTiming: shiftTiming,
                  last_checkin: row?.last_checkin,
                  checkin_time: row?.checkin_time,
                  last_checkin_days_ago: row?.last_checkin_days_ago,
                },
              }));
            }}
          >
            {row?.total_biomax_not_registered || 0}
          </span>
        );
      },
    },
    {
      dataField: "last_checkin",
      text: (
        <div className="tb-head-row">
          <span style={{ marginRight: "10px" }}>Trainer Last Checkin</span>
          <span
            className={`head-icon ${
              allFilters.selectedTrainerLastCheckinSorting === "0"
                ? "active"
                : ""
            }`}
            onClick={() =>
              setAllFilters((prevs) => ({
                ...prevs,
                selectedTrainerLastCheckinSorting:
                  prevs.selectedTrainerLastCheckinSorting === "0" ? "" : "0",
              }))
            }
          >
            <BiArrowUpIcon />
          </span>
          <span
            className={`head-icon ${
              allFilters.selectedTrainerLastCheckinSorting === "1"
                ? "active"
                : ""
            }`}
            onClick={() =>
              setAllFilters((prevs) => ({
                ...prevs,
                selectedTrainerLastCheckinSorting:
                  prevs.selectedTrainerLastCheckinSorting === "1" ? "" : "1",
              }))
            }
          >
            <BiArrowDownIcon />
          </span>
        </div>
      ),
      formatter: (_, row) => {
        return (
          <span
            className="tb-data minWidth150 link"
            style={{
              width: "100px",
              textDecoration: "underline",
              fontWeight: "700",
              cursor: "pointer",
            }}
            onClick={() =>
              setClickValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                userId: row?.trainer_id,
                checkinLogsModal: true,
                type: "trainer",
                rowValue: "trainer",
                clickedType: "last_checkin",
                sendableStatsQPs: `&start_date=${
                  row?.last_checkin || ""
                }&end_date=${row?.last_checkin || ""}`,
              }))
            }
          >
            {convertStraight(row?.last_checkin) || "-"}
            <br />
            {convertTimeRangeHHMMSS(row?.checkin_time) || ""}
            <br />
            {row?.last_checkin_days_ago
              ? `(${row.last_checkin_days_ago?.replace(/_/g, " ")})`
              : ""}
          </span>
        );
      },
    },
    {
      dataField: "shift_details",
      text: "Trainer Shift Timing",
      formatter: (_, row) => {
        const shiftTimings = row?.shift_details?.map((shift) => {
          const startTime = shift?.start_time
            ? moment(shift.start_time, "HH:mm")
                .tz("Asia/Kolkata")
                .format("h:mmA")
            : "";
          const endTime = shift?.end_time
            ? moment(shift.end_time, "HH:mm").tz("Asia/Kolkata").format("h:mmA")
            : "";
          return `${startTime}-${endTime}`;
        });

        const shiftTiming = shiftTimings
          ? shiftTimings?.join(", ")
          : "No Shift Found";

        return (
          <span
            className="tb-data minWidth150 link"
            style={{
              textDecoration: "underline",
              cursor: "pointer",
            }}
            onClick={() => {
              const shiftTimings = row?.shift_details?.map((shift) => {
                const startTime = shift?.start_time
                  ? moment(shift.start_time, "HH:mm")
                      .tz("Asia/Kolkata")
                      .format("h:mmA")
                  : "";
                const endTime = shift?.end_time
                  ? moment(shift.end_time, "HH:mm")
                      .tz("Asia/Kolkata")
                      .format("h:mmA")
                  : "";
                return `${startTime}-${endTime}`;
              });

              const shiftTiming = shiftTimings
                ? shiftTimings?.join(", ")
                : "No Shift Found";

              setClickValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                type: "member",
                clickedType: "members_checkin_under_trainer_shift",
                userId: row?.trainer_id,
                rowData: {
                  who: "trainer",
                  name: row?.trainer_name,
                  mobile: row?.trainer_mobile,
                  email: row?.trainer_email,
                  gym_name: row?.gym_name,
                  shiftTiming: shiftTiming,
                  last_checkin: row?.last_checkin,
                  checkin_time: row?.checkin_time,
                  last_checkin_days_ago: row?.last_checkin_days_ago,
                },
              }));
            }}
            // className="tb-data hoverBlue minWidth150"
          >
            {shiftTiming ? shiftTiming : "-"}
          </span>
        );
      },
    },
    {
      dataField: "trainer_exp_lvl",
      text: "Trainer Experience Level",
      formatter: (_, row) => {
        return (
          <span className="tb-data bold">{row?.trainer_exp_lvl || "NA"}</span>
        );
      },
    },
    {
      dataField: "avg_rating",
      text: "Trainer Average Rating",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius8 bold"
            style={{
              background:
                parseFloat(row?.avg_rating || 0) > 3 ? "#E2EFD5" : "#F3DADA",
              color:
                parseFloat(row?.avg_rating || 0) > 3 ? "#379C00" : "#D90000",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              columnGap: "5px",
            }}
          >
            {parseFloat(row?.avg_rating || 0).toFixed(1) || 0}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-star-fill"
              viewBox="0 0 16 16"
            >
              <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
            </svg>
          </span>
        );
      },
    },
    {
      dataField: "date_onboarding",
      text: "trainer onboarding date",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.date_onboarding || "-"}</span>;
      },
    },
    {
      dataField: "action",
      text: "Trainer Shift",
      formatter: (_, row) => (
        <div className="actionButtonContainer" style={{ gap: "0" }}>
          <button
            type="button"
            className="actionBtn icon clock-icon"
            onClick={(e) => onClickValues(e, row, "shift_details")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-clock-history"
              viewBox="0 0 16 16"
            >
              <path d="M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022zm2.004.45a7 7 0 0 0-.985-.299l.219-.976q.576.129 1.126.342zm1.37.71a7 7 0 0 0-.439-.27l.493-.87a8 8 0 0 1 .979.654l-.615.789a7 7 0 0 0-.418-.302zm1.834 1.79a7 7 0 0 0-.653-.796l.724-.69q.406.429.747.91zm.744 1.352a7 7 0 0 0-.214-.468l.893-.45a8 8 0 0 1 .45 1.088l-.95.313a7 7 0 0 0-.179-.483m.53 2.507a7 7 0 0 0-.1-1.025l.985-.17q.1.58.116 1.17zm-.131 1.538q.05-.254.081-.51l.993.123a8 8 0 0 1-.23 1.155l-.964-.267q.069-.247.12-.501m-.952 2.379q.276-.436.486-.908l.914.405q-.24.54-.555 1.038zm-.964 1.205q.183-.183.35-.378l.758.653a8 8 0 0 1-.401.432z" />
              <path d="M8 1a7 7 0 1 0 4.95 11.95l.707.707A8.001 8.001 0 1 1 8 0z" />
              <path d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5" />
            </svg>
          </button>
        </div>
      ),
    },
  ];

  const tbColumnsBiomaxNotRegistered = [
    {
      dataField: "total_assigned_members",
      text: "Not Assigned members",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius8 hoverBlue"
            style={{
              background: "#BCBBF7",
              color: "#171717",
              padding: "10px 30px",
            }}
            onClick={() => {
              const shiftTimings = row?.shift_details?.map((shift) => {
                const startTime = shift?.start_time
                  ? moment(shift.start_time, "HH:mm")
                      .tz("Asia/Kolkata")
                      .format("h:mmA")
                  : "";
                const endTime = shift?.end_time
                  ? moment(shift.end_time, "HH:mm")
                      .tz("Asia/Kolkata")
                      .format("h:mmA")
                  : "";
                return `${startTime}-${endTime}`;
              });

              const shiftTiming = shiftTimings
                ? shiftTimings?.join(", ")
                : "No Shift Found";

              setClickValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                type: "member",
                clickedType: "not_assigned_members",
                userId: row?.trainer_id,
                rowValue: row?.total_assigned_members || 0,
                rowData: {
                  who: "trainer",
                  name: row?.trainer_name,
                  mobile: row?.trainer_mobile,
                  email: row?.trainer_email,
                  gym_name: row?.gym_name,
                  shiftTiming: shiftTiming,
                  last_checkin: row?.last_checkin,
                  checkin_time: row?.checkin_time,
                  last_checkin_days_ago: row?.last_checkin_days_ago,
                },
              }));
            }}
          >
            {row?.total_assigned_members || 0}
          </span>
        );
      },
    },
    {
      dataField: "total_biomax_registered",
      text: "Biomax Registered Members",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius8 hoverBlue"
            style={{
              background: "#BCBBF7",
              color: "#171717",
              padding: "10px 30px",
            }}
            onClick={() => {
              const shiftTimings = row?.shift_details?.map((shift) => {
                const startTime = shift?.start_time
                  ? moment(shift.start_time, "HH:mm")
                      .tz("Asia/Kolkata")
                      .format("h:mmA")
                  : "";
                const endTime = shift?.end_time
                  ? moment(shift.end_time, "HH:mm")
                      .tz("Asia/Kolkata")
                      .format("h:mmA")
                  : "";
                return `${startTime}-${endTime}`;
              });

              const shiftTiming = shiftTimings
                ? shiftTimings?.join(", ")
                : "No Shift Found";

              setClickValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                userId: row?.trainer_id,
                assignedMemModal: true,
                type: "member",
                clickedType: "biomax_registered",
                rowValue: row?.total_biomax_registered || 0,
                rowData: {
                  who: "trainer",
                  name: row?.trainer_name,
                  mobile: row?.trainer_mobile,
                  email: row?.trainer_email,
                  gym_name: row?.gym_name,
                  shiftTiming: shiftTiming,
                  last_checkin: row?.last_checkin,
                  checkin_time: row?.checkin_time,
                  last_checkin_days_ago: row?.last_checkin_days_ago,
                },
              }));
            }}
          >
            {row?.total_biomax_registered || 0}
          </span>
        );
      },
    },
    {
      dataField: "total_biomax_not_registered",
      text: "Biomax Not Registered Members",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius8 hoverBlue"
            style={{
              background: "#BCBBF7",
              color: "#171717",
              padding: "10px 30px",
            }}
            onClick={() => {
              const shiftTimings = row?.shift_details?.map((shift) => {
                const startTime = shift?.start_time
                  ? moment(shift.start_time, "HH:mm")
                      .tz("Asia/Kolkata")
                      .format("h:mmA")
                  : "";
                const endTime = shift?.end_time
                  ? moment(shift.end_time, "HH:mm")
                      .tz("Asia/Kolkata")
                      .format("h:mmA")
                  : "";
                return `${startTime}-${endTime}`;
              });

              const shiftTiming = shiftTimings
                ? shiftTimings?.join(", ")
                : "No Shift Found";

              setClickValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                userId: row?.trainer_id,
                assignedMemModal: true,
                type: "member",
                clickedType: "biomax_not_registered",
                rowValue: row?.total_biomax_not_registered || 0,
                rowData: {
                  who: "trainer",
                  name: row?.trainer_name,
                  mobile: row?.trainer_mobile,
                  email: row?.trainer_email,
                  gym_name: row?.gym_name,
                  shiftTiming: shiftTiming,
                  last_checkin: row?.last_checkin,
                  checkin_time: row?.checkin_time,
                  last_checkin_days_ago: row?.last_checkin_days_ago,
                },
              }));
            }}
          >
            {row?.total_biomax_not_registered || 0}
          </span>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={clickValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Details Modal"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer">
          {!(
            clickValues.clickedType === "assigned_members" ||
            clickValues.clickedType === "not_assigned_members" ||
            clickValues.clickedType === "biomax_registered" ||
            clickValues.clickedType === "biomax_not_registered" ||
            clickValues.clickedType === "members_checkin_under_trainer_shift"
          ) && (
            <ModalHeadAndClose
              title={`${clickValues.clickedType?.replace(/_/g, " ")} - ${
                clickValues.rowValue ? clickValues.rowValue : ""
              }`}
              onClose={onCloseModal}
            />
          )}

          {clickValues.clickedType === "shift_details" ? (
            <OccupencyDetails queryParametersForAll={shiftFormattedQP} />
          ) : clickValues.clickedType ===
            "members_checkin_under_trainer_shift" ? (
            <TrainerMembers
              user={user}
              prevClickValues={clickValues}
              prevFilters={allFilters}
              onClosePrevModal={onCloseModal}
            />
          ) : clickValues.clickedType === "last_checkin" ? (
            <CheckinReports
              clickValues={clickValues}
              sendableStatsQPs={clickValues.sendableStatsQPs}
              lastCheckinTRDate={true}
            />
          ) : clickValues.clickedType === "assigned_members" ||
            clickValues.clickedType === "not_assigned_members" ||
            clickValues.clickedType === "biomax_registered" ||
            clickValues.clickedType === "biomax_not_registered" ? (
            <ABBdetail
              user={user}
              prevClickValues={clickValues}
              prevFilters={allFilters}
              isNotAssignedMembers={cardName === "not_assigned_members"}
              onClosePrevModal={onCloseModal}
              clickedCard={clickValues.clickedType}
            />
          ) : null}
        </div>
      </Modal>

      {loadingDTM ? (
        <ReactVortoxSpinner />
      ) : (
        <div className="tab-view-table-container overflowAuto separatedTable">
          <PaymentLinkTable
            tableData={tbDatas.allData}
            tableColumns={
              cardName === "not_assigned_members"
                ? tbColumnsBiomaxNotRegistered
                : tbColumns
            }
            tablePagination={tbDatas.pagination}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
          />
        </div>
      )}
    </>
  );
};

export default TrainerMemberTable;
